import SectionHeading from "./SectionHeading";
import { aboutStats, principles, testimonials, editorialPrinciples } from "@/mocks/critter";

export default function AboutSection() {
  return (
    <section id="about" className="scroll-mt-24 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1fr] lg:gap-14">
          {/* left: positioning */}
          <div>
            <SectionHeading
              eyebrow="About Us"
              title="呱呱爆料是谁"
              desc="我们是一支专注商业观察与行业解析的独立内容团队，坚持把『爆料』做成有依据、有逻辑、看得懂的分析。"
            />
            <div className="mt-6 space-y-4 text-sm leading-relaxed text-foreground-700">
              <p>
                呱呱爆料诞生于一个朴素的想法：面对铺天盖地的行业乱象与营销话术，普通人最缺的往往不是情绪，而是一套
                <strong className="font-semibold text-foreground-950">能看穿套路、讲清利益链条</strong>的思维工具。
              </p>
              <p>
                我们长期追踪资本操作、幕后推手与圈内潜规则的典型模式，把它们翻译成清晰的案例与可执行的识别清单。
                与情绪化的传闻不同，我们要求每一篇都尽量给出<strong className="font-semibold text-foreground-950">可查证的来源与因果链</strong>。
              </p>
              <p>
                我们的读者有消费者、有求职者、有中小从业者，也有行业研究者。无论你是谁，我们共同的愿望都是——
                少交点「信息差」的学费，多在决策前多问一句：<strong className="font-semibold text-foreground-950">这背后的账，到底是谁在付？</strong>
              </p>
            </div>

            {/* principles */}
            <div className="mt-8 grid grid-cols-2 gap-4">
              {principles.map((p) => (
                <div key={p.title} className="rounded-lg border border-background-300 bg-background-50 p-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${p.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-3 font-heading text-[15px] font-bold text-foreground-950">{p.title}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.body}</p>
                </div>
              ))}
            </div>
          </div>

          {/* right: stats + testimonials */}
          <div>
            <div className="grid grid-cols-2 gap-4">
              {aboutStats.map((s) => (
                <div key={s.label} className="rounded-lg bg-foreground-950 px-5 py-6 text-background-100">
                  <p className="font-label text-3xl font-bold text-accent-400">
                    {s.value}
                    <span className="text-lg">{s.suffix}</span>
                  </p>
                  <p className="mt-1 text-xs text-background-300">{s.label}</p>
                </div>
              ))}
            </div>

            <div className="mt-6 rounded-lg border border-background-300 bg-background-100 p-6">
              <p className="flex items-center gap-2 font-label text-[11px] uppercase tracking-[0.2em] text-accent-600">
                <i className="ri-community-line"></i> 读者口碑
              </p>
              <div className="mt-4 space-y-5">
                {testimonials.map((t) => (
                  <figure key={t.author}>
                    <p className="text-sm leading-relaxed text-foreground-700">「{t.quote}」</p>
                    <figcaption className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
                      <span className="flex h-6 w-6 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                        <i className="ri-user-smile-line"></i>
                      </span>
                      <span className="font-medium text-foreground-700">{t.author}</span>
                      <span>·</span>
                      <span>{t.role}</span>
                    </figcaption>
                  </figure>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* content principles strip */}
        <div className="mt-8 rounded-lg border border-background-300 bg-background-100 px-6 py-5">
          <p className="flex items-center gap-2 font-label text-[11px] uppercase tracking-[0.2em] text-accent-700">
            <i className="ri-stackshare-line"></i> 内容承诺
          </p>
          <ul className="mt-3 grid grid-cols-1 gap-x-6 gap-y-2 md:grid-cols-3">
            {editorialPrinciples.map((ep) => (
              <li key={ep} className="flex items-start gap-2 text-sm leading-relaxed text-foreground-700">
                <i className="ri-checkbox-circle-line mt-0.5 shrink-0 text-accent-500"></i>
                {ep}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}